import { render, staticRenderFns } from "./ApprovalRequestList.vue?vue&type=template&id=b7a4276c&scoped=true&"
import script from "./ApprovalRequestList.vue?vue&type=script&lang=js&"
export * from "./ApprovalRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalRequestList.vue?vue&type=style&index=0&id=b7a4276c&lang=scss&scoped=true&"
import style1 from "./ApprovalRequestList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a4276c",
  null
  
)

export default component.exports